import { of, switchMap, tap, startWith, debounceTime, merge, fromEvent, distinctUntilChanged, map } from 'rxjs';

import { replaceViewContainer, renderTemplate, getParentAttr } from './ui.js';
import { findSections } from './knowledge-api.js';

export function createSimilarSectionsView() {
    return of(undefined).pipe(
        switchMap(() => {
            let root = renderTemplate('similar-sections-view');
            replaceViewContainer(root);

            let form = root.querySelector('form');
            let searchContextEl = form.querySelector('.context textarea');

            let sessionKey = 'global-search-context';
            let savedContext = sessionStorage.getItem(sessionKey);
            if (savedContext) {
                searchContextEl.value = savedContext;
            }

            let searchContext$ = fromEvent(searchContextEl, 'input').pipe(
                debounceTime(300),
                startWith(undefined),
                map(() => (searchContextEl.value || '').trim()),
                tap(context => sessionStorage.setItem(sessionKey, context)),
                distinctUntilChanged(),
            );

            let nearestSectionsEl = root.querySelector('.nearest-sections');

            let nearestSections$ = searchContext$.pipe(
                tap(() => nearestSectionsEl.textContent = 'Loading…'),
                switchMap(context => findSections(context)),
            );

            let renderNearestSections$ = nearestSections$.pipe(
                tap(nearestSections => {
                    nearestSectionsEl.innerHTML = '';
                    for (let sec of nearestSections) {
                        let secEl = renderTemplate('global-nearest-section-widget');
                        secEl.setAttribute('data-section-id', sec.id);
                        secEl.setAttribute('data-doc-id', sec.doc_id);
                        secEl.setAttribute('data-collection-id', sec.collection_id);
                        secEl.querySelector('.text').textContent = sec.text;
                        secEl.querySelector('.cosine-distance').textContent = sec.cos_dist.toFixed(3);
                        if (sec.doc_source_uri) {
                            let srcEl = secEl.querySelector('.source-uri');
                            srcEl.textContent = sec.doc_source_uri;
                            srcEl.href = sec.doc_source_uri;
                            secEl.querySelector('.source-uri-container').classList.remove('hidden');
                        }
                        let collectionLinkEl = secEl.querySelector('.collection-link');
                        collectionLinkEl.textContent = sec.collection_name;
                        collectionLinkEl.href = `#collection/${sec.collection_id}`;
                        secEl.querySelector('.edit-section').addEventListener('click', handleEditSection, false);
                        secEl.querySelector('.edit-document').addEventListener('click', handleEditDocument, false);
                        nearestSectionsEl.appendChild(secEl);
                    }
                }),
            );

            return merge(
                renderNearestSections$,
            );
        }),
    );
}

function handleEditSection(event) {
    let sectionId = getParentAttr(event.target, 'data-section-id');
    window.location.href = `#section/${sectionId}`;
}

function handleEditDocument(event) {
    let docId = getParentAttr(event.target, 'data-doc-id');
    window.location.href = `#document/${docId}`;
}
